import { USER_ACCESS_TOKEN, USER_JWT_TOKEN } from '@/auth/authMockData';

const TOKEN_KEY = 'access_token';
const ID_TOKEN_KEY = 'id_token';
const REFRESH_TOKEN = 'refresh_token';
const TOKEN_EXPIRED_AT = 'token_expired_at';

const defaultState = {
};

const getters = {
};

const actions = {
  async mockLogin(context) {
    // Simulate 400ms delay.
    await new Promise(resolve => setTimeout(resolve, 400));

    const tokenExpiresAt = Date.now() + parseInt(3600000, 10);

    localStorage.setItem(TOKEN_KEY, USER_ACCESS_TOKEN);
    localStorage.setItem(ID_TOKEN_KEY, USER_JWT_TOKEN);
    localStorage.setItem(REFRESH_TOKEN, USER_ACCESS_TOKEN);
    localStorage.setItem(TOKEN_EXPIRED_AT, tokenExpiresAt);

    context.commit('authentication/setToken', USER_ACCESS_TOKEN, { root: true });
    context.commit('authentication/setIdToken', USER_JWT_TOKEN, { root: true });
    context.commit('authentication/setRefreshToken', USER_ACCESS_TOKEN, { root: true });
    context.commit('authentication/setTokenExpiredAt', tokenExpiresAt, { root: true });
  },
  async mockLogout(context, { loginUrl }) {
    // Simulate 400ms delay.
    await new Promise(resolve => setTimeout(resolve, 400));

    // Remove auth artifacts from local storage.
    localStorage.removeItem(TOKEN_EXPIRED_AT);
    await context.dispatch('authentication/clearTokens', {}, { root: true });

    // In Mock API mode we will just perform a 'hard' redirect to the loginUrl.
    window.location = loginUrl;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
};
